var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formulate-option-stepper" },
    _vm._l(_vm.localOptions, function (option, index) {
      return _c(
        "div",
        {
          key: option.value,
          staticClass: "step-group",
          class: {
            "last-step-group": index === _vm.localOptions.length - 1,
          },
        },
        [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "step-item",
                class: {
                  "step-item-active": _vm.context.model >= option.value,
                  "step-item-inactive": _vm.isExceedMaxValue(option.value),
                },
                attrs: { type: "button" },
                on: {
                  click: function () {
                    return _vm.onOptionSelect(option)
                  },
                },
              },
              [_vm._v(" " + _vm._s(option.value) + " ")]
            ),
            index !== _vm.localOptions.length - 1
              ? _c(
                  "div",
                  {
                    staticClass: "step-progress",
                    class: {
                      "step-progress-inactive": _vm.isExceedMaxValue(
                        option.value
                      ),
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "step-progress-bar",
                      style: {
                        width: _vm.getOptionProgress(option) + "%",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "d-flex" }, [
            _c("p", { staticClass: "step-item-size text-center h5" }, [
              _vm._v(" " + _vm._s(option.label) + " "),
            ]),
            index !== _vm.localOptions.length - 1
              ? _c("div", { staticClass: "step-progress-size" })
              : _vm._e(),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }